<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">사용자 권한 관리</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">사용자 권한 관리</h3>
        <article>
          <div class="searchArea">
            <div class="total">
              총<span>{{ listCnt }}</span
              >건
            </div>
            <div class="searchBox">
              <search-box @emitSearch="searchBtn" @emitPerChange="changePerPage">
                <template slot="searchCondition">
                  <option value="1">사용자아이디</option>
                  <option value="2">사용자명</option>
                </template>
              </search-box>
            </div>
          </div>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <table>
                <caption>
                  메뉴관리 테이블
                </caption>
                <colgroup>
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                  <col style="width: auto" />
                  <col style="width: 15%" />
                  <col style="width: 15%" />
                  <col style="width: 15%" />
                  <col style="width: 15%" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">
                      <p class="checkbox">
                        <input type="checkbox" id="chk-on" class="hidden" v-model="allChecked" @click="checkedAll" />
                        <label for="chk-on"></label>
                      </p>
                    </th>
                    <th scope="col">번호</th>
                    <th scope="col">사용자아이디</th>
                    <th scope="col">사용자명</th>
                    <th scope="col">사용자 유형</th>
                    <th scope="col">권한</th>
                    <th scope="col">등록여부</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="nodate" v-if="nodata">
                    <td colspan="6">조회된 데이터가 없습니다.</td>
                  </tr>
                  <tr v-for="(item, index) in calData" :key="index">
                    <td>
                      <p class="checkbox">
                        <input
                          type="checkbox"
                          :id="'itemCheck_' + item.userId"
                          v-model="checkedValues"
                          :value="index"
                          @change="checkboxCkc()"
                        />
                        <label :for="'itemCheck_' + item.userId"></label>
                      </p>
                    </td>
                    <td>{{ startOffset + index + 1 }}</td>
                    <td>{{ item.userId }}</td>
                    <td>{{ item.userNm }}</td>
                    <td>{{ item.mberTyNm }}</td>
                    <td>
                      <select v-model="item.authorCode" title="권한 선택">
                        <option value="">선택하세요.</option>
                        <option v-for="(item, index) in authorManageList" :key="index" :value="item.authorCode">
                          {{ item.authorNm }}
                        </option>
                      </select>
                    </td>
                    <td v-if="item.regYn == 'Y'">등록</td>
                    <td v-if="item.regYn == 'N'">미등록</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--btnArea-->
          <div class="btnArea txt-right">
            <!-- <button type="button" class="btn border" @click="deleteConfirm">선택삭제</button> -->
            <button type="button" class="btn border" @click="listInsertAuthBtn">등록</button>
          </div>

          <!-- 페이지네이션 -->
          <v-pagination v-model="curPageNum" @input="clearChecked" :length="numOfPages"></v-pagination>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import SearchBox from '../../../components/SearchBox.vue';

export default {
  data() {
    return {
      nodata: false,
      listData: [],
      listCnt: 0,
      authorManageList: [],
      curPageNum: 1,
      dataPerPage: 10,
      checkedValues: [],
      allChecked: false,
      searchCondition: '',
      searchKeyword: '',
    };
  },

  mounted() {
    this.searchBtn();
  },

  components: {
    SearchBox,
  },

  methods: {
    async searchBtn(searchCondition, searchKeyword) {
      const res = await axios('get', '/api/auth/authorGroupList.json', {
        searchCondition: searchCondition,
        searchKeyword: searchKeyword,
      });

      const data = res.data;
      this.checkedValues = [];
      this.allChecked = false;
      if (!data.resultList || data.resultList.length <= 0) {
        this.listData = [];
        this.nodata = true;
        this.curPageNum = 1;
        this.listCnt = 0;
        return;
      }
      this.listData = data.resultList;
      this.authorManageList = data.authorManageList;
      this.nodata = false;
      // this.curPageNum = 1;
      this.listCnt = this.listData.length;
    },

    changePerPage(dataPerPage) {
      this.dataPerPage = dataPerPage;
      this.curPageNum = 1;
    },

    // checkedAll() {
    //   if (!this.allChecked) {
    //     this.checkedValues = [];
    //     this.calData.forEach(element => {
    //       this.checkedValues.push(
    //         element.uniqId + ';' + element.authorCode + ';' + element.regYn + ';' + element.mberTyCode,
    //       );
    //     });
    //   } else {
    //     this.checkedValues = [];
    //   }
    // },

    checkedAll() {
      if (!this.allChecked) {
        this.checkedValues = [];
        this.calData.forEach((element, index) => {
          this.checkedValues.push(index);
        });
      } else {
        this.checkedValues = [];
      }
    },

    async listInsertAuthBtn() {
      if (this.existCheckBox()) {
        let apiParams = new FormData();
        const data = [];
        for (const i of this.checkedValues) {
          data.push(this.calData[Number(i)].uniqId + ';' + this.calData[Number(i)].authorCode + ';' + this.calData[Number(i)].regYn + ';' + this.calData[Number(i)].mberTyCode,)
        }
        apiParams.append('arrData', data);
        await axios('post', '/api/auth/authorGroupInsert.json', apiParams);
        alert('수정되었습니다.');
        this.searchBtn();
      }
    },

    async listDeleteAuthBtn() {
      let apiParams = new FormData();
      const data = [];
        for (const i of this.checkedValues) {
          data.push(this.calData[Number(i)].uniqId + ';' + this.calData[Number(i)].authorCode + ';' + this.calData[Number(i)].regYn + ';' + this.calData[Number(i)].mberTyCode,)
        }
      apiParams.append('arrData', data);
      await axios('post', '/api/auth/authorGroupDelete.json', apiParams);
      await this.searchBtn();
    },

    clearChecked() {
      this.checkedValues = [];
      this.allChecked = false;
    },

    existCheckBox() {
      if (this.checkedValues.length < 1) {
        alert('선택된 체크박스가 없습니다.');
        return false;
      }
      return true;
    },

    deleteConfirm() {
      if (this.existCheckBox()) {
        this.$confirm({
          message: `삭제하시겠습니까?`,
          button: {
            no: '아니오',
            yes: '예',
          },
          callback: confirm => {
            if (confirm) {
              this.listDeleteAuthBtn();
            }
          },
        });
      }
    },

    checkboxCkc() {
      if (this.calData.length === this.checkedValues.length) {
        this.allChecked = true;
        return;
      }
      this.allChecked = false;
    },
  },

  computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
    calData() {
      if (this.listData.length < 0) {
        return;
      }
        return this.listData.slice(this.startOffset, this.endOffset);
    },
  },
};
</script>
